import { render, staticRenderFns } from "./BranchExpenses.vue?vue&type=template&id=307690d2"
import script from "./BranchExpenses.vue?vue&type=script&lang=js"
export * from "./BranchExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports